import { render, staticRenderFns } from "./RatesManagementHeader.vue?vue&type=template&id=a53589be&"
import script from "./RatesManagementHeader.vue?vue&type=script&lang=ts&"
export * from "./RatesManagementHeader.vue?vue&type=script&lang=ts&"
import style0 from "./RatesManagementHeader.vue?vue&type=style&index=0&id=a53589be&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports